
import { CommonEnums } from '../../common.enums';

export class HdfsCmd_Inst {
    dxFlow_Id: number;
    hdfsCmd_Inst_Id: number;
    nm: string;
    description: string;;
    ver: string;
    hdfsCmd: string;
    valid_Cd: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    conn_Valid_Cd: string;
    disableFlg: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dxFlow_Id == CommonEnums.defaults.LONG_VAL;
        this.hdfsCmd_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.hdfsCmd = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.conn_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.retryEnabled = CommonEnums.defaults.STRING_EMPTY;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;

    }

    static parse(hdfsCmd_InstTmp: HdfsCmd_Inst): HdfsCmd_Inst {
        let hdfsCmd_Inst: HdfsCmd_Inst = new HdfsCmd_Inst();
        hdfsCmd_Inst.copyFrom(hdfsCmd_InstTmp);
        return hdfsCmd_Inst;
    }

    copy(): HdfsCmd_Inst {
        let hdfsCmd_InstTmp: HdfsCmd_Inst = new HdfsCmd_Inst();

        hdfsCmd_InstTmp.dxFlow_Id = this.dxFlow_Id;
        hdfsCmd_InstTmp.hdfsCmd_Inst_Id = this.hdfsCmd_Inst_Id;
        hdfsCmd_InstTmp.nm = this.nm;
        hdfsCmd_InstTmp.description = this.description;
        hdfsCmd_InstTmp.ver = this.ver;
        hdfsCmd_InstTmp.hdfsCmd = this.hdfsCmd;
        hdfsCmd_InstTmp.valid_Cd = this.valid_Cd;
        hdfsCmd_InstTmp.updateBy = this.updateBy
        hdfsCmd_InstTmp.lastUpdateBy = this.lastUpdateBy;
        hdfsCmd_InstTmp.updateDt = this.updateDt;
        hdfsCmd_InstTmp.conn_Valid_Cd = this.conn_Valid_Cd;
        hdfsCmd_InstTmp.disableFlg = this.disableFlg;
        hdfsCmd_InstTmp.retryEnabled = this.retryEnabled;
        hdfsCmd_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        hdfsCmd_InstTmp.retryWaitTime = this.retryWaitTime;

        return hdfsCmd_InstTmp;
    }

    copyFrom(hdfsCmd_InstTmp: HdfsCmd_Inst): void {

        this.dxFlow_Id = hdfsCmd_InstTmp.dxFlow_Id;
        this.hdfsCmd_Inst_Id = hdfsCmd_InstTmp.hdfsCmd_Inst_Id;
        this.nm = hdfsCmd_InstTmp.nm;
        this.description = hdfsCmd_InstTmp.description;
        this.ver = hdfsCmd_InstTmp.ver;
        this.hdfsCmd = hdfsCmd_InstTmp.hdfsCmd;
        this.valid_Cd = hdfsCmd_InstTmp.valid_Cd;
        this.updateBy = hdfsCmd_InstTmp.updateBy;
        this.lastUpdateBy = hdfsCmd_InstTmp.lastUpdateBy;
        this.updateDt = hdfsCmd_InstTmp.updateDt;
        this.conn_Valid_Cd = hdfsCmd_InstTmp.conn_Valid_Cd;
        this.disableFlg = hdfsCmd_InstTmp.disableFlg;
        this.retryEnabled = hdfsCmd_InstTmp.retryEnabled;
        this.numOfRetryAttempts = hdfsCmd_InstTmp.numOfRetryAttempts;
        this.retryWaitTime= hdfsCmd_InstTmp.retryWaitTime;

    }

    compare(hdfsCmd_InstTmp: HdfsCmd_Inst): string {
        let hdfsCmd_InstString: string =this.toString(false);
        let hdfsCmd_InstTmpString: string = hdfsCmd_InstTmp.toString(false);

        if (hdfsCmd_InstString != hdfsCmd_InstTmpString) {
            return hdfsCmd_InstString + ', ' + hdfsCmd_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str:string="HdfsCmd_Inst[dxFlow_Id=" + this.dxFlow_Id +
            ",hdfsCmd_Inst_Id=" + this.hdfsCmd_Inst_Id +
            ",nm=" + this.nm +
            ",description=" + this.description +
            ",ver =" + this.ver +
            ",hdfsCmd=" + this.hdfsCmd +
            ",valid_Cd=" + this.valid_Cd +
            ",updateBy=" + this.updateBy +
            ",updateDt=" + this.updateDt +
            ",conn_Valid_Cd =" + this.conn_Valid_Cd +
            ",disableFlg =" + this.disableFlg +
            ",retryEnabled =" + this.retryEnabled +
            ",retryWaitTime="+ this.retryWaitTime +
            ",numOfRetryAttempts =" + this.numOfRetryAttempts + "]";

    

            if (isNotCompare) {
                str += ", lastUpdateBy=" + this.lastUpdateBy; 
               
            }
    
            str += ']';
    
            return str;
        }
    }

